import { render, staticRenderFns } from "./twofactor-switch.vue?vue&type=template&id=406eb2ce&scoped=true"
import script from "./twofactor-switch.vue?vue&type=script&lang=ts"
export * from "./twofactor-switch.vue?vue&type=script&lang=ts"
import style0 from "./twofactor-switch.vue?vue&type=style&index=0&id=406eb2ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406eb2ce",
  null
  
)

export default component.exports